import { collection, query, where, orderBy, limit, getDocs, getCountFromServer } from "firebase/firestore";

export const MATRICULA_INICIAL = 50000;
const TENTATIVAS = 50;

/**
 * Próxima matrícula de praticante: a maior matrícula NUMÉRICA da coleção + 1.
 *
 * Antes era `count(correntes) + 5000`, que reemitia números já usados sempre
 * que a contagem caía (desativação, fusão de duplicado) ou quando se atribuía
 * matrícula sem criar documento (o "completar" da importação). Em 2026-09-15
 * havia 6.110 matrículas repetidas entre os correntes
 * (docs/correcoes/MATRICULAS-REPETIDAS-2026-09.md e
 * `scripts/auditar-matriculas-praticantes.mjs`).
 *
 * - Olha a coleção inteira, arquivadas incluídas: um número de versão antiga
 *   continua sendo daquela pessoa.
 * - `>= 0` limita a consulta a números — o Firestore ordena por tipo e, na ordem
 *   decrescente, qualquer texto viria antes.
 * - Metade das matrículas antigas está gravada como TEXTO ("12345"), fora do
 *   alcance da ordenação numérica; por isso o candidato é conferido nos dois
 *   tipos antes de ser devolvido.
 * - Não protege contra duas criações simultâneas: as duas podem ler o mesmo
 *   máximo. Para isso seria preciso um contador transacional (backlog).
 */
export async function proximaMatricula(db) {
  const colecao = collection(db, "praticantes");
  const maior = await getDocs(query(colecao, where("matriculaCBTKD", ">=", 0), orderBy("matriculaCBTKD", "desc"), limit(1)));
  let candidato = maior.empty ? MATRICULA_INICIAL : Math.floor(Number(maior.docs[0].data().matriculaCBTKD)) + 1;

  for (let tentativa = 0; tentativa < TENTATIVAS; tentativa++, candidato++) {
    const emUso = await getCountFromServer(query(colecao, where("matriculaCBTKD", "in", [candidato, String(candidato)])));
    if (emUso.data().count === 0) return candidato;
  }
  throw new Error(`Não foi possível gerar uma matrícula livre (${TENTATIVAS} números seguidos em uso).`);
}
